const confirmLanguage = (
  newLanguage,
  setMessageError,
  setAttention,
  clearStorage,
  loaderRef,
  setFetchError,
  setChosenLanguage,
) => {
  loaderRef.current.continuousStart();
  // fetch(`https://surveyapp.onrcx.net/${window.location.href.split(/sid=/)[1].split('&')[0]}/api/SaveAnswers`, {
  fetch(
    `http://test.onrcx.com/${window.location.href.split(/sid=/)[1].split("&")[0]}/api/SaveAnswers`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ProjectCode: sessionStorage.sid,
        ProjectId: newLanguage,
        Answers: null,
        Page: null,
        UserScreen: `${
          window.innerWidth > 0 ? window.innerWidth : window.screen.width
        }x${
          window.innerHeight > 0 ? window.innerHeight : window.screen.height
        }`,
        Version: sessionStorage.getItem("vid"),
        UserId: `${sessionStorage.getItem("uid")}`,
        TabId: `${sessionStorage.getItem("tid")?.replace("Z", "")}`,
        UserAgent: `${navigator.userAgent}`,
        QueryParams: `${new URLSearchParams(window.location.search).toString()}`,
      }),
    },
  )
    .then((res) => res.json())
    .then((data) => {
      if (data.Error) {
        setMessageError(
          data.Error.replace(/< br \/>/g, " ")
            .replace(/<br \/>/g, " ")
            .replace(/<br\/>/g, " "),
        );
        setAttention(data?.Attention);
        clearStorage();
        loaderRef.current.complete();
      } else if (data) {
        setChosenLanguage(newLanguage);
        console.log("Successful save");
      } else {
        //debugger
        setFetchError(true);
        loaderRef.current.complete();
      }
    })
    .catch((err) => {
      loaderRef.current.complete();
      //debugger
      setFetchError(true);
    });
};

export default confirmLanguage;
